import { toast, Slide } from "react-toastify";

export const toastNotify = (message, type) => {
  if (type === "success" || type === "Success") {
    return toast.success(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Slide,
    });
  } else if (type === "warning" || type === "Warning") {
    return toast.warn(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Slide,
    });
  } else if (type === "error" || type === "Error") {
    return toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Slide,
      hideProgressBar: true,
    });
  }
};
